<div class="container-fluid">
  <!-- Page Header with Action Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Staff Success Report</h1>

    <!-- Action Buttons -->
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
      <div class="d-flex flex-wrap gap-1">
        <button style="background-color: transparent !important; border: none;"
          (click)="printReport()"
          type="button"
          mat-icon-button
          class="me-1 mb-1"
          matTooltip="Print staff success report"
          matTooltipPosition="below"
          aria-label="Print staff success report">
          <mat-icon style="color: #1C3F8B;">print</mat-icon>
        </button>

        <button
          style="color:#fff; background-color: #0AC92B !important; border-color: #0AC92B !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="exportReport()">
          <mat-icon>file_download</mat-icon>
          <span>Export to CSV</span>
        </button>

        <button
          style="color:#fff; background-color: #007bff !important; border-color: #007bff !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="refreshData()">
          <mat-icon>refresh</mat-icon>
          <span>Refresh</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Error Alerts Section -->
  <div *ngIf="reportErrors.length > 0" class="mb-3">
    <div *ngFor="let error of reportErrors; let i = index" class="alert alert-warning alert-dismissible fade show" role="alert">
      <strong>Configuration Warning:</strong>
      <span *ngIf="error.instructor"> {{ error.instructor }} - </span>
      {{ error.message }}
      <span *ngIf="error.enrollment_id"> (Enrollment ID: {{ error.enrollment_id }})</span>
      <button type="button" class="btn-close" (click)="dismissError(i)" aria-label="Close"></button>
    </div>
  </div>

  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Filter</mat-panel-title>
      <mat-panel-description>
        <app-filter-results-panel [parameters]="queryParams"></app-filter-results-panel>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <form #f="ngForm" class="form">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Date Range</mat-label>
            <input #dateRangeInput matInput
              [value]="dateRangeDisplayValue"
              placeholder="Select date range"
              readonly
              name="dateRange">
            <button matSuffix mat-icon-button type="button" (click)="openDateRangePicker()">
              <mat-icon>calendar_today</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Quarter</mat-label>
            <mat-select [(ngModel)]="quarter" name="quarter"
              (selectionChange)="onQuarterChange($event)"
              [disabled]="isDateRangeActive">
              <mat-option value="">None</mat-option>
              <mat-option *ngFor="let q of quarters" [value]="q.key">
                {{ q.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Week</mat-label>
            <mat-select [(ngModel)]="week" name="week"
              (selectionChange)="loadData()"
              [disabled]="isDateRangeActive">
              <mat-option *ngFor="let element of WeeksForYearData" [value]="element.key">
                {{ element.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Year</mat-label>
            <mat-select [(ngModel)]="year" name="year"
              (selectionChange)="onYearChange($event); loadData()"
              [disabled]="isDateRangeActive">
              <mat-option>None</mat-option>
              <mat-option *ngFor="let element of LastFourYearsData" [value]="element.key">
                {{ element.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <section class="section">
          <div class="float-end bring-inline">
            <button (click)="resetForm()" color="primary" mat-flat-button class="me-1">
              Clear
            </button>
          </div>
        </section>
      </div>
    </form>
  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

  <!-- Instructor Tables -->
  <div class="row">
    <div class="col-12 col-xl-6 mt-4" *ngFor="let instructor of instructorData">
      <h3>{{instructor.instructor_name}}</h3>

      <!-- Scrolls sideways on narrow screens; the Category column stays pinned so every number keeps its label. -->
      <div class="table-responsive">
        <table mat-table [dataSource]="instructor.rows" class="w-100">
          <!-- Category Column -->
          <ng-container matColumnDef="category" sticky>
            <th mat-header-cell *matHeaderCellDef>
              <span [matTooltip]="columnHelp.category" matTooltipClass="report-tooltip">
                Category <mat-icon class="help-icon-inline">help_outline</mat-icon>
              </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span class="text-nowrap" [matTooltip]="getCategoryTooltip(element, instructor)" matTooltipClass="report-tooltip">
                {{element.category}}
              </span>
            </td>
          </ng-container>

          <!-- Tried Column -->
          <ng-container matColumnDef="tried">
            <th mat-header-cell *matHeaderCellDef>
              <span [matTooltip]="columnHelp.tried" matTooltipClass="report-tooltip">
                # Tried <mat-icon class="help-icon-inline">help_outline</mat-icon>
              </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span [class.clickable]="hasStudents(element.tried_students)"
                    [class.has-data]="hasStudents(element.tried_students)"
                    [matTooltip]="getStudentsTooltip(element.tried_students, '# Tried')"
                    matTooltipClass="report-tooltip"
                    (click)="showStudentDetails(element.tried_students, '# Tried')">
                {{element['# Tried'] || '-'}}
              </span>
            </td>
          </ng-container>

          <!-- Sold Column -->
          <ng-container matColumnDef="sold">
            <th mat-header-cell *matHeaderCellDef>
              <span [matTooltip]="columnHelp.sold" matTooltipClass="report-tooltip">
                # Sold <mat-icon class="help-icon-inline">help_outline</mat-icon>
              </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span [class.clickable]="hasStudents(element.sold_students)"
                    [class.has-data]="hasStudents(element.sold_students)"
                    [matTooltip]="getStudentsTooltip(element.sold_students, '# Sold')"
                    matTooltipClass="report-tooltip"
                    (click)="showStudentDetails(element.sold_students, '# Sold')">
                {{element['# Sold'] || '-'}}
              </span>
            </td>
          </ng-container>

          <!-- % Sold Column -->
          <ng-container matColumnDef="percentWk">
            <th mat-header-cell *matHeaderCellDef>
              <span [matTooltip]="columnHelp.percent" matTooltipClass="report-tooltip">
                % Sold <mat-icon class="help-icon-inline">help_outline</mat-icon>
              </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span [matTooltip]="getPercentTooltip(element, false)" matTooltipClass="report-tooltip">
                {{element['% Sold'] !== null ? element['% Sold'] + '%' : '-'}}
              </span>
            </td>
          </ng-container>

          <!-- Sales Value Column -->
          <ng-container matColumnDef="salesValueRange">
            <th mat-header-cell *matHeaderCellDef class="text-end">
              <span [matTooltip]="columnHelp.value" matTooltipClass="report-tooltip">
                $ Value <mat-icon class="help-icon-inline">help_outline</mat-icon>
              </span>
            </th>
            <td mat-cell *matCellDef="let element" class="text-end">
              <span class="text-nowrap"
                    [class.clickable]="hasStudents(element.sold_students)"
                    [matTooltip]="getSalesValueTooltip(element, false)"
                    matTooltipClass="report-tooltip"
                    (click)="showStudentDetails(element.sold_students, '$ Value')">
                {{element['Sales Value'] !== null ? (element['Sales Value'] | studioCurrency:0) : '-'}}
              </span>
            </td>
          </ng-container>

          <!-- Tried YTD Column -->
          <ng-container matColumnDef="triedYtd">
            <th mat-header-cell *matHeaderCellDef>
              <span [matTooltip]="columnHelp.triedYtd" matTooltipClass="report-tooltip">
                # Tried YTD <mat-icon class="help-icon-inline">help_outline</mat-icon>
              </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span [class.clickable]="hasStudents(element.tried_ytd_students)"
                    [class.has-data]="hasStudents(element.tried_ytd_students)"
                    [matTooltip]="getStudentsTooltip(element.tried_ytd_students, '# Tried YTD')"
                    matTooltipClass="report-tooltip"
                    (click)="showStudentDetails(element.tried_ytd_students, '# Tried YTD')">
                {{element['# Tried YTD'] || '-'}}
              </span>
            </td>
          </ng-container>

          <!-- Sold YTD Column -->
          <ng-container matColumnDef="soldYtd">
            <th mat-header-cell *matHeaderCellDef>
              <span [matTooltip]="columnHelp.soldYtd" matTooltipClass="report-tooltip">
                # Sold YTD <mat-icon class="help-icon-inline">help_outline</mat-icon>
              </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span [class.clickable]="hasStudents(element.sold_ytd_students)"
                    [class.has-data]="hasStudents(element.sold_ytd_students)"
                    [matTooltip]="getStudentsTooltip(element.sold_ytd_students, '# Sold YTD')"
                    matTooltipClass="report-tooltip"
                    (click)="showStudentDetails(element.sold_ytd_students, '# Sold YTD')">
                {{element['# Sold YTD'] || '-'}}
              </span>
            </td>
          </ng-container>

          <!-- % Sold (YTD) Column -->
          <ng-container matColumnDef="percentYtd">
            <th mat-header-cell *matHeaderCellDef>
              <span [matTooltip]="columnHelp.percentYtd" matTooltipClass="report-tooltip">
                % Sold (YTD) <mat-icon class="help-icon-inline">help_outline</mat-icon>
              </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span [matTooltip]="getPercentTooltip(element, true)" matTooltipClass="report-tooltip">
                {{element['% Sold (YTD)'] !== null ? element['% Sold (YTD)'] + '%' : '-'}}
              </span>
            </td>
          </ng-container>

          <!-- Sales Value YTD Column -->
          <ng-container matColumnDef="salesValueYtd">
            <th mat-header-cell *matHeaderCellDef class="text-end">
              <span [matTooltip]="columnHelp.valueYtd" matTooltipClass="report-tooltip">
                $ Value YTD <mat-icon class="help-icon-inline">help_outline</mat-icon>
              </span>
            </th>
            <td mat-cell *matCellDef="let element" class="text-end">
              <span class="text-nowrap"
                    [class.clickable]="hasStudents(element.sold_ytd_students)"
                    [matTooltip]="getSalesValueTooltip(element, true)"
                    matTooltipClass="report-tooltip"
                    (click)="showStudentDetails(element.sold_ytd_students, '$ Value YTD')">
                {{element['Sales Value YTD'] !== null ? (element['Sales Value YTD'] | studioCurrency:0) : '-'}}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>

</div>
